/*
JP SABINI customisations
*** change 1 - drawer could stay stuck open when closed during its 0.4 s opening animation
*/
class SimilarProductsDrawer extends MenuDrawer {
  constructor() {
    super();
 
    this.setClasses({
      open: 'similar-products--open',
      opening: 'similar-products--opening',
      closing: 'similar-products--closing'
    });
 
    this.content = this.querySelector('[data-similar-content]');
    this.spinnerHTML = this.content.innerHTML;
    this.cache = new Map();
 
    this.querySelector('.similar-products__close').addEventListener('click', (event) => {
      this.closeMenuDrawer(event, this.querySelector('summary'));
    });
  }
 
  /* JP SABINI - change 1 - BEGINNING */
  // MenuDrawer never clears the "opening" body class on close, and its opening
  // animation adds "open" 0.4 s later even if the drawer was closed meanwhile.
  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) document.body.classList.remove(this.classes.opening);
    super.closeMenuDrawer(event, elementToFocus);
  }
 
  openAnimation() {
    let animationStart;
 
    const handleAnimation = (time) => {
      if (animationStart === undefined) animationStart = time;
 
      if (time - animationStart < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else if (document.body.classList.contains(this.classes.opening)) {
        document.body.classList.remove(this.classes.opening);
        document.body.classList.add(this.classes.open);
      }
    };
 
    window.requestAnimationFrame(handleAnimation);
  }
  /* JP SABINI - change 1 - END */
 
  openFor(productId) {
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.querySelector('summary').click();
    }
    this.load(productId);
  }
 
  load(productId) {
    if (this.currentId === productId) return;
    this.currentId = productId;
    this.content.innerHTML = this.spinnerHTML;
 
    const cached = this.cache.get(productId);
    if (cached !== undefined) {
      this.render(productId, cached);
      return;
    }
 
    fetch(`${this.dataset.url}&product_id=${productId}`)
      .then((response) => response.text())
      .then((text) => {
        const grid = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-similar-grid]');
        const html = grid ? grid.innerHTML : '';
        this.cache.set(productId, html);
        this.render(productId, html);
      })
      .catch((error) => {
        console.error('SimilarProducts:', error);
        // Not cached: closing and reopening the drawer retries the fetch
        if (this.currentId === productId) this.currentId = null;
        this.render(productId, '');
      });
  }
 
  render(productId, html) {
    // The shopper may have opened another card while this fetch was in flight
    if (this.currentId !== productId && this.cache.has(productId)) return;
    this.content.innerHTML = html.trim().length
      ? html
      : `<p class="similar-products__empty">${this.dataset.emptyText}</p>`;
  }
}
customElements.define('similar-products-drawer', SimilarProductsDrawer);
 
class SimilarProductsButton extends HTMLElement {
  constructor() {
    super();
 
    this.addEventListener('click', this.open.bind(this));
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      this.open();
    });
  }
 
  open() {
    const drawer = document.querySelector('similar-products-drawer');
    if (drawer) drawer.openFor(this.dataset.productId);
  }
}
customElements.define('similar-products-button', SimilarProductsButton);
 